import { Link } from "react-router-dom";

const Logo = ({ className }: { className?: string }) => {
    return (
        <Link to="/admin" className="flex items-center gap-2">
            <img src='/logo.svg' alt="Roda de Prêmios" className={`h-10 ${className}`} />
        </Link>
    )
}

export default Logo;